import React, { useMemo } from "react";
//components
import { Box } from "@material-ui/core";
import { FilterIcon, FTLBadge, FTLButton, FTLSearchField, FTLSelect, } from "ftl-dashboards-ui-kit";
export const FTLListPage = ({ children, tableComponent, headerComponent, filters, searchProps, onShowHiddenMenu, filtersCount = 0, }) => {
    const filterComponents = useMemo(() => filters &&
        filters.map((filter, index) => {
            return (React.createElement(FTLSelect, Object.assign({ key: filter.label || index, isClearable: true, isSearchable: true, type: "filter", size: "small", width: "small", BoxProps: { mr: 4, mb: 4, flexShrink: "none" } }, filter)));
        }), [filters]);
    return (React.createElement(React.Fragment, null,
        headerComponent,
        React.createElement(Box, { display: "flex", mt: 6, overflow: "auto", flexShrink: 0 },
            searchProps && (React.createElement(Box, Object.assign({ width: "200px", mr: 4, mb: 4, flexShrink: "none" }, searchProps.BoxProps),
                React.createElement(FTLSearchField, Object.assign({}, searchProps)))),
            filterComponents,
            onShowHiddenMenu && (React.createElement(Box, { mb: 4 },
                React.createElement(FTLButton, { color: "secondary", startIcon: React.createElement(FilterIcon, { color: "inherit" }), endIcon: filtersCount ? (React.createElement(FTLBadge, { backgroundColor: "toggleCheckedEnable" }, filtersCount)) : null, onClick: onShowHiddenMenu }, "\u0424\u0438\u043B\u044C\u0442\u0440\u044B"))),
            children),
        tableComponent));
};
export default FTLListPage;
//# sourceMappingURL=index.js.map